const { createObject, createString, traversePropertiesString } = require('../../shared');

module.exports.declarations = function (appData, formData, outData, formDataKey){

  //TODO: Inquire on replace Existing Coverage with Travis
  if (!outData.error && !createObject(appData, "declarations", {})) {
    outData.error = "Cannot create coverage info";
  }

  if (!outData.error && !createString(appData.declarations, "ssn", traversePropertiesString(formData,[formDataKey,['ssn']]), true)) {
    outData.error = "Missing SSN";
  }

};


// WEBPACK FOOTER //
// ./src/containers/Applications/shared/appConverters/MBA/declarations.js